export const HREF = {
  ROOT: '',
  INFO: 'info',
  ACCOUNT: 'account',
  ORDERS: 'order-history',

  CHECKOUT: 'checkout',
  CHECKOUT_CONFIRMATION: 'confirmation',
  CHECKOUT_DECLINE: 'decline',

  HOME: 'marketplace',
  BRANDSTORE: 'marketplace',
  CATEGORY_PRODUCTS: 'marketplace/category',
  RECENTLY_VIEWED: 'marketplace/recently-viewed',
  RECENTLY_ADDED: 'marketplace/recently-added',
  MOST_POPULAR: 'marketplace/most-popular',
  PRODUCTS: 'products',
  PRODUCT_DETAILS: 'products/:id',
  WISHLIST: 'wishlist',
  BRANDS_DIRECTORY: 'brands-directory',
  SALE: 'sale',
  SEARCH_RESULTS: 'search-results',
  APPLE_CATEGORY: 'marketplace/category-apple/',

  FAQ: 'faq',
  RETURNS_AND_REFUNDS: 'return-and-refund',
  SHIPPING_AND_DELIVERY: 'shippingpolicy',
  TERMS_AND_CONDITIONS: 'terms-and-conditions',
  TERMS_AND_CONDITIONS_APPLE: 'apple-terms-and-conditions',

  CART: 'cart',

  NOT_FOUND: 'not-found',
  NOT_AVAILABLE: 'not-available',
  LOGOUT: 'logout',
  MISSING_INFORMATION: 'missing-information',

  CATEGORY_PRODUCTS_withparam: 'marketplace/category/:id',
  BRAND_PRODUCTS_withParam: 'marketplace/:id',
};
